import { Field, Form, withFormik } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Error } from '../../../../components';
var TermsConditionsForm = observer(function (props) {
    var appStore = props.appStore, summaryStore = props.summaryStore, values = props.values;
    var wholesaleCustomerCode = props.config.wholesaleCustomerCode;
    return (React.createElement(Form, null,
        React.createElement("span", { className: "terms-and-conditions form-control", dangerouslySetInnerHTML: {
                __html: summaryStore.termsAndConditions,
            }, "data-disabled": true }),
        wholesaleCustomerCode === 'EA' && (React.createElement("div", { className: "small" },
            React.createElement("br", null),
            React.createElement("p", { className: "small" },
                "By agreeing to these terms and conditions, you:",
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("ol", { className: "small" },
                    React.createElement("li", { className: "small" }, "Confirm that you have read and understood these terms;"),
                    React.createElement("li", { className: "small" },
                        ' ',
                        "Agree to be bound by the EnergyAustralia nbn\u2122 Standard Form of Agreement (SFOA); and",
                        ' '),
                    React.createElement("li", { className: "small" }, "Agree to pay your account monthly via an automated recurring direct debit from your nominated debit or credit card.")),
                React.createElement("br", null),
                "Do you confirm that you have read and understood these terms and conditions and that you agree to be bound by the EnergyAustralia nbn\u2122 Standard Form of Agreement?"),
            React.createElement("br", null))),
        React.createElement("label", { htmlFor: "termsAndConditions", className: "checkbox checkbox-square" },
            React.createElement(Field, { id: "termsAndConditions", name: "termsAndConditions", type: "checkbox", checked: values.termsAndConditions }),
            React.createElement("small", { className: "label" }, "I agree to the Terms & Conditions listed above"),
            React.createElement("div", null,
                React.createElement(Error, { name: "termsAndConditions" }))),
        React.createElement("section", { className: "footer-buttons" },
            React.createElement("button", { type: "button", className: "btn btn-shade btn-back", onClick: appStore.previousStep }, "Back"),
            React.createElement("button", { type: "submit", className: "btn btn-next" }, "Next"))));
});
export var TermsConditions = inject('appStore', 'summaryStore', 'config')(withFormik({
    handleSubmit: function (values, bag) {
        bag.props.appStore.clearAlerts();
        bag.props.summaryStore.setDetailsFromForm(values);
        bag.props.appStore.nextStep();
    },
    mapPropsToValues: function (_a) {
        var summaryStore = _a.summaryStore;
        return summaryStore.termsAndConditionsDetails.formValues
            ? summaryStore.termsAndConditionsDetails.formValues
            : summaryStore.termsAndConditionsDetails.formInitialValues;
    },
    validate: function (values) {
        var errors = {};
        if (!values['termsAndConditions']) {
            errors.termsAndConditions = 'You must accept the terms and conditions';
        }
        return errors;
    },
})(TermsConditionsForm));
//# sourceMappingURL=TermsConditions.js.map